import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IDashboardSupplier } from '../../interfaces/dashboard';
import { ITaskFilter } from '../../interfaces/task-filter';
import { ITaskInfo } from '../../interfaces/task-info';
import { CustomerService } from '../../services';
import { DashboardService } from '../../services';
import { TaskService } from '../../services';
import { flatten } from '../../utils/flatten';
import { ISupplierSchedule } from '../../interfaces/supplier-schedule';
import moment from 'moment';

@Component({
  selector: 'dashboard-supplier',
  styleUrls: ['./dashboard-supplier.component.css'],
  templateUrl: './dashboard-supplier.component.html',
})
export class DashboardSupplierComponent implements OnInit {
  inboxType_VmeInbox = 1;
  inboxType_SupplierExistingJobs = 2;
  inboxType_CustomerInbox = 3;

  public supplierInboxType_InboxDirect = 2;
  public supplierInboxType_InboxMatched = 3;
  public supplierInboxType_InboxBidWatch = 4;
  public supplierInboxType_Live = 15;

  public subscription: Subscription;
  public taskList: any[];
  public from: string;
  public to: string;
  public filterVal: ITaskFilter;

  public data: IDashboardSupplier = {};
  public jobsByDay: any = {};
  public jobsByDayOptions: any = {};
  public jobsByHour: any = {};
  public jobsByHourOptions: any = {};

  public _selectedTask: ITaskInfo;
  public logo: string = '';
  public showUpdateAvaialbilityDialog: boolean = false;

  constructor(
    private taskService: TaskService,
    private dashboardService: DashboardService,
    private router: Router,
    private customerService: CustomerService,
  ) {
    this.customerService.getOrganisationNameAndLogo().then((org) => {
      this.logo = org.logo;
    });
  }

  ngOnInit() {
    this.initDefaultFilter();
    this.refreshTasks();
    // let timer = TimerObservable.create(0, 30000);
    // this.subscription = timer.subscribe(t => {
    //     this.refreshTasks();
    // });

    this.jobsByDayOptions = {
      scaleShowValues: true,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              autoSkip: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };

    this.jobsByHourOptions = {
      scaleShowValues: true,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              autoSkip: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };

    this.dashboardService.getSupplier().then((result) => {
      this.data = result;
      this.verifyAvailabilityInfo();

      this.jobsByDay = {
        labels: this.data.jobsByDayLabels,
        datasets: [
          {
            label: 'Jobs',
            backgroundColor: '#42A5F5',
            borderColor: '#1E88E5',
            data: this.data.jobsByDayValues,
          },
        ],
      };

      this.jobsByHour = {
        labels: this.data.jobsByHourLabels,
        datasets: [
          {
            label: 'Plan',
            backgroundColor: 'red',
            borderColor: '#1E88E5',
            data: this.data.jobsByHourPlanValues,
          },
          {
            label: 'Fact',
            backgroundColor: 'green',
            borderColor: '#1E88E5',
            data: this.data.jobsByHourFactValues,
          },
        ],
      };
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: Number.MAX_SAFE_INTEGER / 2,
      sortField: '', // ASC
      sortOrder: 1,
      filters: {
        inboxType: { value: this.inboxType_SupplierExistingJobs },
        from: {},
        to: {},
        taskType: { value: 0 },
        eregionId: { value: 0 },
        taskStep: { value: null },
        isTrackingData: { value: true },
        isDirectionsData: { value: true },
      },
    };
  }

  refreshTasks() {
    this.taskService.GetLiveTasks(flatten(this.filterVal)).then((data) => {
      console.log(data);
      this.taskList = data.items;
    });
  }

  goToInbox(event: Event, selectedInboxTab) {
    event.preventDefault();
    this.router.navigate(['/app/supplierinbox'], {
      queryParams: { selectedTab: selectedInboxTab, isGridView: false },
    });
  }

  goToExistingJobs(event: Event, selectedInboxTab) {
    event.preventDefault();
    this.router.navigate(['/app/existingjobs'], {
      queryParams: { selectedTab: selectedInboxTab, isGridView: false },
    });
  }

  taskClick(item) {
    this.router.navigate(['app/jobscreen/' + item.jobId]);
  }

  verifyAvailabilityInfo() {
    let supplierSchedule: ISupplierSchedule = this.data && this.data.supplierSchedule;
    if (
      !supplierSchedule ||
      !supplierSchedule.validity ||
      moment(supplierSchedule.validity).isBefore(moment())
    ) {
      this.showUpdateAvaialbilityDialog = true;
    }
  }
  goToMySchedule() {
    this.router.navigate(['/app/supplieravailability']);
  }
}
